module.exports = __webpack_public_path__ + "img/wp-new-habit-card6.719b9c38.jpg";